// Role doors, icons and the last-used door. Kept apart from RolePicker so pages that only need these skip its animation library.
import { Backpack, GraduationCap, Building2, HeartHandshake, ShieldCheck, UserCog } from "lucide-react";

// Brand colours from the logo's colour pairs (BumaMark): one per door.
export const ROLE_TILES = [
  { id: "student", icon: Backpack, bg: "#E8590C", to: "/join" },
  { id: "trainer", icon: GraduationCap, bg: "#0A9B5F", to: "/login?as=trainer" },
  { id: "center_admin", icon: Building2, bg: "#0248E2", to: "/login?as=center_admin" },
  { id: "parent", icon: HeartHandshake, bg: "#D6336C", to: "/family/login" },
];
export const ROLE_ICONS = { student: Backpack, trainer: GraduationCap, center_admin: Building2, parent: HeartHandshake, super_admin: ShieldCheck, role_manager: UserCog };
export const rememberRole = (r) => { try { localStorage.setItem("buma:lastRole", r); } catch (e) { /* noop */ } };
export const lastRole = () => { try { return localStorage.getItem("buma:lastRole"); } catch (e) { return null; } };
// Signed out inside a staff area (session ended): straight back to that person's door, no picker.
export const staffLoginPath = (fallback) => { const r = lastRole(); return r === "parent" ? "/family/login" : `/login?as=${r && r !== "student" ? r : fallback}`; };
